import {useMountEffect} from '@logistics-frontend/hooks'
import {useCallback} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {type AddressPin, useFetchAddressPin} from '../../../../../../../api/address'
import {useConfigContext} from '../../../../../../../utils/contexts/ConfigContext'

/**
 * Предзаполняет адрес отправления текущей локацией пользователя.
 * @param fieldName Название поля в стейте
 * @param isSource Является ли адрес - точкой отправления ("Откуда")
 */
export const usePrefetchAddress = (fieldName: string, isSource: boolean) => {
  const {location} = useConfigContext()
  const {getValues} = useFormContext()
  const {field} = useController({name: fieldName})

  const updateState = useCallback(
    (addressPin: AddressPin) => {
      field.onChange(addressPin)
    },
    [field],
  )

  const {mutate: mutateAddressPin} = useFetchAddressPin({onSuccess: updateState})

  useMountEffect(() => {
    const value = getValues(fieldName)

    // Если это точка отправления и адрес не заполнен
    if (isSource && !value?.title) {
      mutateAddressPin({coordinates: location})
    }
  })
}
